import { SearchItemRepository } from '../../../core/repositories/search_item/search_item_repository';
import { JsEnv } from '../../../core/models/js_env';
import { KeywordDetailJsEnv } from '../models/keyword_detail_js_env';
import { SearchWordConditionContainer } from '../views/pc/searchword_condition_container';
import { TypedEvent } from '../../../core/typed_event';
import { KeywordDetail } from '../models/keyword_detail';
import { KeywordDetailCondition } from '../models/keyword_detail_condition';
import { GetTotalItemRequest } from '../models/keyword_detail_condition_env';

const VARIATION_COUNT_LIMIT = 5000;

export class SearchTotalItemAction {
  static readonly UPDATE_EVENT = new TypedEvent<KeywordDetailJsEnv>();
  private static state: KeywordDetail;
  private static keywordDetailCondition: KeywordDetailCondition;
  private static searchItemRepository: SearchItemRepository;

  static init(env: JsEnv) {
    this.state = new KeywordDetail(env.PAGE);
    this.keywordDetailCondition = new KeywordDetailCondition();
    this.searchItemRepository = new SearchItemRepository();
    this.searchButtonClicked();
    this.changeCondition();
    return new SearchWordConditionContainer(this.state.getModel());
  }

  private static changeCondition() {
    document.forms['searchCondition'].addEventListener('change', (element) => {
      this.setSupplierCondition(element.target);
      this.changeSearchCondition();
    });
  }

  private static searchButtonClicked() {
    document.getElementById('submitSearchCondition')?.addEventListener('click', () => {
      if (
        this.keywordDetailCondition.hasAnyCondition(
          this.keywordDetailCondition.getSelectCondition()
        )
      ) {
        // エラーメッセージの表示
        this.state.setErrorMessage(
          '下記の内容をご確認ください。',
          '検索キーワードを入力するか、商品の種類を１つ以上選択してください。'
        );
        this.UPDATE_EVENT.trigger(this.state.getModel());
        this.showErrorMessage();
        return;
      }
      document.forms['searchCondition'].submit();
    });
  }

  private static setSupplierCondition(element: HTMLElement) {
    const target = element as HTMLInputElement;
    if (target.id === 'supplier') {
      (document.getElementById('supplierId') as HTMLInputElement).value = target.value.split(
        '_'
      )[0];
      (document.getElementById('catalogCode') as HTMLInputElement).value = target.value.split(
        '_'
      )[1];
    }
  }

  private static async changeSearchCondition() {
    const conditon: GetTotalItemRequest = this.keywordDetailCondition.getSelectCondition();

    // 検索条件が何も無い場合は、商品件数を取得しない
    if (this.keywordDetailCondition.hasAnyCondition(conditon)) {
      this.hideTotalCount();
      return;
    }
    // Webフロントサーバ側の商品検索API経由で取得する
    this.searchItemRepository
      .sendRequest(this.keywordDetailCondition.createTotalItemParameter(conditon))
      .then((response) => {
        this.refreshErrorMessage();
        // 商品件数が取得出来なかった場合は処理を終了する
        if (response.indexOf('が該当しました。') == -1) {
          this.hideTotalCount();
          return;
        }
        this.showTotalCount(response);
      })
      .catch(() => {
        this.hideTotalCount();
      });
  }

  private static showErrorMessage() {
    this.refreshErrorMessage();
    const searchWord: HTMLInputElement = document.getElementById('warning') as HTMLInputElement;
    searchWord.style.display = 'block';
  }

  private static refreshErrorMessage() {
    const searchWord: HTMLInputElement = document.getElementById('warning') as HTMLInputElement;
    searchWord.style.display = 'none';
  }

  private static showTotalCount(response: string) {
    this.refreshErrorMessage();
    const totalItem: HTMLElement = document.getElementById('totalItem') as HTMLElement;
    const informationMessageArea: HTMLElement = document.getElementById(
      'informationMessageArea'
    ) as HTMLElement;
    const submitSearchCondition: HTMLElement = document.getElementById(
      'submitSearchCondition'
    ) as HTMLElement;
    totalItem.innerHTML = response;
    totalItem.style.display = '';
    if (
      Number(
        totalItem.querySelector('[data-variation-count]')?.getAttribute('data-variation-count')
      ) > VARIATION_COUNT_LIMIT
    ) {
      informationMessageArea.style.display = '';
      submitSearchCondition.setAttribute('disabled', 'disabled');
      submitSearchCondition.classList.add('is-disabled');
    } else {
      informationMessageArea.style.display = 'none';
      submitSearchCondition.removeAttribute('disabled');
      submitSearchCondition.classList.remove('is-disabled');
    }
  }

  private static hideTotalCount() {
    this.refreshErrorMessage();
    const totalItem: HTMLElement = document.getElementById('totalItem') as HTMLElement;
    const informationMessageArea: HTMLElement = document.getElementById(
      'informationMessageArea'
    ) as HTMLElement;
    const submitSearchCondition: HTMLElement = document.getElementById(
      'submitSearchCondition'
    ) as HTMLElement;
    totalItem.style.display = 'none';
    informationMessageArea.style.display = 'none';
    submitSearchCondition.removeAttribute('disabled');
    submitSearchCondition.classList.remove('is-disabled');
  }
}
